import axios from "axios";

const login = (values) => {
  return axios.post(`${process.env.REACT_APP_MAIN_URL}/login`, values);
};

export default login;
